import { PromoAnalyticsService } from '@analytics/feature';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  OnDestroy,
  OnInit,
  Optional,
  Output,
} from '@angular/core';
import { CmsFormattedResponsiveBannerComponent, CmsSimpleResponsiveBannerComponent } from '@promo/const';
import { CmsComponentData, PageSlotComponent } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { SdSimpleResponsiveBannerComponent } from '../simple-responsive-banner';

@Component({
  selector: 'sd-formatted-responsive-banner',
  templateUrl: './formatted-responsive-banner.component.html',
  styleUrls: ['./formatted-responsive-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdFormattedResponsiveBannerComponent
  extends SdSimpleResponsiveBannerComponent
  implements OnInit, OnDestroy
{
  @HostBinding('class') bannerClass: string;

  @Output() bannerClassEvent: EventEmitter<string> = new EventEmitter();

  subscription = new Subscription();

  componentData$: Observable<CmsFormattedResponsiveBannerComponent>;

  constructor(
    component: CmsComponentData<CmsSimpleResponsiveBannerComponent>,
    promoAnalyticsService: PromoAnalyticsService,
    @Optional() pageSlotComponent: PageSlotComponent,
  ) {
    super(component, promoAnalyticsService, pageSlotComponent);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.subscription.add(
      this.getBannerClass().subscribe((bannerClass) => {
        // если баннер лежит внутри рандом баннера,
        // то класс должен примениться к обертке
        if (this.bannerClassEvent.observed) {
          this.bannerClassEvent.emit(bannerClass);
        } else {
          this.bannerClass = bannerClass;
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getBannerClass(): Observable<string> {
    return this.componentData$.pipe(
      map((data) => {
        return [
          // баннер должен занимать кол-во колонок указанное в настройках
          // компонента или 12 колонок, если значение не указано
          (data.mobileBannerFormat || 'F12').replace('F', 'col-'),
          data.tabletBannerFormat && data.tabletBannerFormat.replace('F', 'col-md-'),
          data.desktopBannerFormat && data.desktopBannerFormat.replace('F', 'col-lg-'),
          data.widescreenBannerFormat && data.widescreenBannerFormat.replace('F', 'col-xl-'),
        ]
          .filter(Boolean)
          .join(' ');
      }),
      distinctUntilChanged(),
    );
  }
}
